/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Level_OkInputs */

const en_us2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const pt_br2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivelado`)
};

const es_419_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivelado`)
};

const pt_pt2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivelado`)
};

const fr_fr2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De niveau`)
};

const de_de2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade`)
};

const it_it2_body_assessment_level_ok = /** @type {(inputs: Body_Assessment_Level_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In bolla`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Body_Assessment_Level_OkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_level_ok = /** @type {((inputs?: Body_Assessment_Level_OkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Level_OkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_level_ok(inputs)
	if (locale === "es-419") return es_419_body_assessment_level_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_level_ok(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_level_ok(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_level_ok(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_level_ok(inputs)
	return en_us2_body_assessment_level_ok(inputs)
});
export { body_assessment_level_ok as "body-assessment.level_ok" }